import { Box, Spinner } from '@chakra-ui/react';

export const CenteredProgress = () => (
  <Box mt={8} display="flex" justifyContent="center">
    <Spinner size="xl" role="loading" />
  </Box>
);
